import { FC } from 'react';
import { TableRow, TableCell, Box, Tooltip } from '@mui/material';
import { MadeInStoreComponent } from '../../../../app/services/api/generated';
import UpdateIcon from '@mui/icons-material/Update';
import { useTranslation } from 'react-i18next';

type Props = {
    item: MadeInStoreComponent;
}

const ComponentRow: FC<Props> = ({ item }) => {
  const { t } = useTranslation('common');
  return (
    <TableRow>
      <TableCell>
        {item.componentItemNumber}
      </TableCell>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {item.componentNewItemNumber && (
            <Tooltip
              title={t('inTransition', { newItemNumber: item.componentNewItemNumber })}
              slotProps={{ tooltip: { sx: { maxWidth: 'none', whiteSpace: 'nowrap' } } }}
            >
              <UpdateIcon sx={{ fontSize: 18, mr: 1, mb: 2 }} />
            </Tooltip>
          )}
          {item.componentDescription}
        </Box>
      </TableCell>
      <TableCell>
        {item.uom}
      </TableCell>
      <TableCell>
        {Number(item.quantity).toFixed(2)}
      </TableCell>
      <TableCell>
        {Number(item.stockOnHandQuantity).toFixed(2)}
      </TableCell>
      <TableCell>
        {Number(item.totalYield).toFixed(2)}
      </TableCell>
    </TableRow>
  );
};

export default ComponentRow;